var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hull-inspections-tab',{ref:"tabHullInspections",attrs:{"vessel":_vm.vessel}})
}
var staticRenderFns = []

export { render, staticRenderFns }